import Text, { TextProps } from "./Text"

import "./Text.less"

export default function TextBodyText({ className, ...props }: TextProps) {
  return <Text className={`TextBodyText ${className || ""}`} {...props} />
}
